
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-home",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-home"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"}}),_c('path',{attrs:{"d":"M9 22V12h6v10"}})])
          )
        }
      }
    